@if (device$ | async) {
  @if (currentCompany$ | async; as company) {
    <div class="grid field col-12">
      <div class="grid field col-12">
        <h2>Device Details</h2>
      </div>

      <div class="grid field col-12">
        <!-- Device Properties -->

        <!-- Id -->
        <div class="grid field col-12">
          <div class="col-12 md:col-2">
            <label>Id</label>
          </div>
          <div class="col-12 md:col-6">
            <input type="text" pInputText placeholder="Enter Device Id" [(ngModel)]="device.id"
              [disabled]="!isNew" />
              @if (modelInvalid && !device.id) {
                <div class="grid field col-12">
                  <label style="color:red; font-weight:bold;">Id is required!</label>
                </div>
              }
            </div>
          </div>

          <!-- Name -->
          <div class="grid field col-12">
            <div class="col-12 md:col-2">
              <label>Name</label>
            </div>
            <div class="col-12 md:col-6">
              <input type="text" pInputText placeholder="Enter Device Name" [(ngModel)]="device.name" />
              @if (modelInvalid && !device.name) {
                <div class="grid field col-12">
                  <label style="color:red; font-weight:bold;">Name is required!</label>
                </div>
              }
            </div>
          </div>

          <!-- Prefix -->
          <div class="grid field col-12">
            <div class="col-12 md:col-2">
              <label>Category</label>
            </div>
            <div class="col-12 md:col-6">
              <p-select [options]="deviceCategories" [(ngModel)]="device.category" (onChange)="onCategoryChange()"></p-select>
              @if (modelInvalid && !device.category) {
                <div class="grid field col-12">
                  <label style="color:red; font-weight:bold;">Category is required!</label>
                </div>
              }
            </div>
          </div>

          <!-- Company Selection -->
          <div class="grid field col-12">
            <div class="col-12 md:col-2">
              <label>Company</label>
            </div>
            <div class="col-12 md:col-6">
              <span>{{ company?.companyName }}</span>

            </div>
          </div>

          <!-- TCP Configuration -->
          @if (device.category == 'TCP') {
            <app-tcp-device [(ngModel)]="device.tcpDeviceConfiguration"
            class="col-12"></app-tcp-device>
          }


          <!-- Measurment Channel Configuration -->
          @if (wellKnownMeasurements$ | async; as wellKnownMeasurements) {

            <app-device-configuration
              [(ngModel)]="device.measurementChannelConfigurations" [company]="company"
              [wellKnownMeasurements]="wellKnownMeasurements" (errors)="handleConfigurationErrors($event)"
            class="col-12"></app-device-configuration>
          }

          <!-- Action Buttons -->
          <div class="grid field col-12">
            @if (isNew) {
              <button pButton class="mr-2" (click)="saveDevice()">Create
              </button>
            }
            @if (!isNew) {
              <button pButton class="mr-2" (click)="saveDevice()">Update
              </button>
            }
            <button pButton (click)="returnToDeviceList()">Cancel
            </button>
          </div>
        </div>
      </div>
    }
  }
  <!--Invalid Model Dialog-->
  <p-dialog header="Validation Errors" [(visible)]="showModelInvalidDialog" [modal]="true" [style]="{width: '450px'}"
    [minY]="70" [baseZIndex]="2000" [dismissableMask]="true">
    <div>
      <p>Please correct the following issues before saving:</p>
      <ul style="margin-top: 10px; padding-left: 20px;">
        @for (error of validationErrors; track error) {
          <li style="margin-bottom: 5px; color: #d32f2f;">
            {{ error }}
          </li>
        }
      </ul>
    </div>
    <p-footer>
      <button type="button" pButton (click)="closeInvalidModelDialog()">
        <i pButtonIcon class="fa-check"></i>
        <span pButtonLabel>OK</span>
      </button>
    </p-footer>
  </p-dialog>
